import http from '../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
export default {

  getPage(params) {
    return http.requestPost(apiPre + service.ops + '/ops/faultRepair/listPage', params)
  },
  delete(params) {
    return http.requestDelete(apiPre + service.ops + '/ops/faultRepair/deleteById/' + params, {})
  },
  getDtoById(params) {
    return http.requestGet(apiPre + service.ops + '/ops/faultRepair/getById/' + params, {})
  },
  insert(params) {
    return http.requestPost(apiPre + service.ops + '/ops/faultRepair/insert', params)
  },
  update(params) {
    return http.requestPut(apiPre + service.ops + '/ops/faultRepair/updateById', params)
  }

}



// WEBPACK FOOTER //
// ./src/module/maintenanceCenter/api/faultRepair.js